// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rGCaT","col":"styles_col__5maXZ","actions":"styles_actions__2ma3k","conflict":"styles_conflict__3It1l"};